// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"97":"4ffaaa4f","225":"b119f067","301":"ed1968dd","682":"a8d558c9"}[chunkId] + ".chunk.css";
};